import React, { useEffect, useRef } from 'react';

import { useApplicationState, useLabel } from '@atlas/core';
import { Icon, Label, Tooltip } from '@atlas/ui';

import MoneyValueCustomCurrency from 'src/components/MoneyValueCustomCurrency/MoneyValueCustomCurrency';

const TOOLTIP_ICON_SIZE = 12;

const ClientProfileHeader = () => {
  const { account: { id, login } = {}, wallet } = useApplicationState();
  const { BONUS = 0, CASH = 0, FROZEN = 0 } = wallet.detailedBalance;
  const scrollElement = useRef(null);

  useEffect(() => {
    const layoutElement = document.getElementsByClassName('layout-wrapper')[0];

    if (layoutElement) {
      scrollElement.current = layoutElement;
    }
  }, []);

  const totalBalance = BONUS + CASH + FROZEN;
  const realBalance = CASH + FROZEN;

  const realBalanceTooltipMessageWithLocked = useLabel('real_balance_tooltip_message_with_locked', {
    availableNow: CASH,
    locked: FROZEN,
  });
  const realBalanceTooltipMessage = useLabel('real_balance_tooltip_message', {
    availableNow: CASH,
  });
  const bonusBalanceTooltipMessage = useLabel('bonus_balance_tooltip_message', {
    bonusBalance: BONUS,
  });
  const bonusBalanceTooltipMessageWhenEmpty = useLabel('bonus_balance_tooltip_message_when_empty', {
    bonusBalance: BONUS,
  });

  return (
    <div className="user-profile-group-header">
      <div className="user-info">
        <span className="user-name title-small-text">{login}</span>
        <span className="user-id sub-title-text">ID {id}</span>
      </div>

      <div className="user-balance">
        <div className="sub-title-xsmall-300-text">
          <Label message="total_balance" />:
        </div>
        <MoneyValueCustomCurrency
          className="total-balance-value title-bold-text"
          value={totalBalance}
        />
        <div className="user-balance-items">
          <div className="user-balance-item">
            <div className="user-balance-item-label-wrap">
              <Label
                className="user-balance-item-label sub-title-xsmall-300-text"
                message="real_balance"
              />

              <Tooltip
                className="user-balance-item"
                message={
                  FROZEN > 0 ? realBalanceTooltipMessageWithLocked : realBalanceTooltipMessage
                }
                placement="bottom"
                scrollElement={scrollElement.current}
                trigger="touch"
              >
                <Icon
                  height={TOOLTIP_ICON_SIZE}
                  name="notification-info"
                  width={TOOLTIP_ICON_SIZE}
                />
              </Tooltip>
            </div>

            <MoneyValueCustomCurrency className="title-small-bold-text" value={realBalance} />
          </div>

          <div className="user-balance-item">
            <div className="user-balance-item-label-wrap">
              <Label
                className="user-balance-item-label sub-title-xsmall-300-text"
                message="bonus_balance_profile"
              />

              <Tooltip
                className="user-balance-item"
                message={
                  BONUS > 0 ? bonusBalanceTooltipMessage : bonusBalanceTooltipMessageWhenEmpty
                }
                placement="bottom"
                scrollElement={scrollElement.current}
                trigger="touch"
              >
                <Icon
                  height={TOOLTIP_ICON_SIZE}
                  name="notification-info"
                  width={TOOLTIP_ICON_SIZE}
                />
              </Tooltip>
            </div>

            <MoneyValueCustomCurrency className="title-small-bold-text" value={BONUS} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProfileHeader;
